import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import arLocale from "i18n-iso-countries/langs/ar.json";

countries.registerLocale(enLocale);
countries.registerLocale(arLocale);

/**
 * Curated Arabic translations for cities of major Arab countries.
 * Keys are the canonical English names returned by `country-state-city`.
 * Cities not present here fall back to the English name.
 */
const AR_CITIES = {
    OM: {
        Muscat: "مسقط",
        Salalah: "صلالة",
        Sohar: "صحار",
        Nizwa: "نزوى",
        Sur: "صور",
        Ibri: "عبري",
        Rustaq: "الرستاق",
        Bahla: "بهلاء",
        Khasab: "خصب",
        Ibra: "إبراء",
        "Suwayq": "السويق",
        "Al Suwayq": "السويق",
        "As Suwayq": "السويق",
        Buraimi: "البريمي",
        "Al Buraimi": "البريمي",
        Buraymi: "البريمي",
        "Al Buraymi": "البريمي",
        "Saham": "صحم",
        "Adam": "أدم",
        Bidiya: "بدية",
        Bidbid: "بدبد",
        Quriyat: "قريات",
        Mahut: "محوت",
        Manah: "منح",
        "Saiq": "سيق",
        Samail: "سمائل",
        "Sufalat Samail": "سفالة سمائل",
        Rakhyut: "رخيوت",
        Shinas: "شناص",
        Liwa: "لوى",
        Dhank: "ضنك",
        Mudhaybi: "المضيبي",
        Khaburah: "الخابورة",
        "Al Khaburah": "الخابورة",
        Barka: "بركاء",
        Bawshar: "بوشر",
        "Bayt al Awabi": "بيت العوابي",
        "Dib Dibba": "دبا",
        Hayma: "هيما",
        Izki: "إزكي",
        "Madha al Jadidah": "مدحاء الجديدة",
        Yanqul: "ينقل",
        "Oman Smart Future City": "مدينة عمان الذكية",
    },
    SA: {
        Riyadh: "الرياض",
        Jeddah: "جدة",
        Mecca: "مكة المكرمة",
        Medina: "المدينة المنورة",
        Dammam: "الدمام",
        Khobar: "الخبر",
        Tabuk: "تبوك",
        Abha: "أبها",
        "Ta'if": "الطائف",
        Taif: "الطائف",
        Buraidah: "بريدة",
        Khamis: "خميس مشيط",
        "Khamis Mushait": "خميس مشيط",
        Hail: "حائل",
        Najran: "نجران",
        Jubail: "الجبيل",
        Yanbu: "ينبع",
        Dhahran: "الظهران",
        Hofuf: "الهفوف",
        Qatif: "القطيف",
        Jizan: "جازان",
        "Al Bahah": "الباحة",
    },
    AE: {
        "Abu Dhabi": "أبو ظبي",
        Dubai: "دبي",
        Sharjah: "الشارقة",
        "Ras Al Khaimah": "رأس الخيمة",
        "Ras al-Khaimah": "رأس الخيمة",
        Ajman: "عجمان",
        Fujairah: "الفجيرة",
        "Umm al Qaywayn": "أم القيوين",
        "Al Ain": "العين",
        Khor: "خور فكان",
        "Khor Fakkan": "خور فكان",
    },
    QA: {
        Doha: "الدوحة",
        "Al Wakrah": "الوكرة",
        "Al Khor": "الخور",
        "Al Rayyan": "الريان",
        "Umm Salal": "أم صلال",
        "Madinat ash Shamal": "مدينة الشمال",
        "Mesaieed": "مسيعيد",
        "Dukhan": "دخان",
    },
    BH: {
        Manama: "المنامة",
        Riffa: "الرفاع",
        Muharraq: "المحرق",
        "Hamad Town": "مدينة حمد",
        "Isa Town": "مدينة عيسى",
        Sitra: "سترة",
        Budaiya: "البديع",
        Jidhafs: "جد حفص",
    },
    KW: {
        "Kuwait City": "مدينة الكويت",
        Hawalli: "حولي",
        Salmiya: "السالمية",
        Jahra: "الجهراء",
        "Al Ahmadi": "الأحمدي",
        "Al Farwaniyah": "الفروانية",
        Mubarak: "مبارك الكبير",
        "Mubarak Al-Kabeer": "مبارك الكبير",
    },
    EG: {
        Cairo: "القاهرة",
        Alexandria: "الإسكندرية",
        Giza: "الجيزة",
        Luxor: "الأقصر",
        Aswan: "أسوان",
        Hurghada: "الغردقة",
        "Sharm El Sheikh": "شرم الشيخ",
        "Sharm el-Sheikh": "شرم الشيخ",
        Suez: "السويس",
        "Port Said": "بورسعيد",
        Mansoura: "المنصورة",
        Tanta: "طنطا",
        Ismailia: "الإسماعيلية",
        "Asyut": "أسيوط",
        Faiyum: "الفيوم",
        Zagazig: "الزقازيق",
        Damietta: "دمياط",
        Minya: "المنيا",
        Sohag: "سوهاج",
        Beni: "بني سويف",
        "Beni Suef": "بني سويف",
    },
    JO: {
        Amman: "عمّان",
        Zarqa: "الزرقاء",
        Irbid: "إربد",
        Aqaba: "العقبة",
        Salt: "السلط",
        Mafraq: "المفرق",
        Madaba: "مادبا",
        Jerash: "جرش",
        Karak: "الكرك",
        "Al Ramtha": "الرمثا",
    },
    IQ: {
        Baghdad: "بغداد",
        Basra: "البصرة",
        Mosul: "الموصل",
        Erbil: "أربيل",
        Najaf: "النجف",
        Karbala: "كربلاء",
        Sulaymaniyah: "السليمانية",
        Kirkuk: "كركوك",
        Ramadi: "الرمادي",
        Fallujah: "الفلوجة",
        Tikrit: "تكريت",
        Samarra: "سامراء",
    },
    SY: {
        Damascus: "دمشق",
        Aleppo: "حلب",
        Homs: "حمص",
        Latakia: "اللاذقية",
        Hama: "حماة",
        Tartus: "طرطوس",
        Daraa: "درعا",
        Idlib: "إدلب",
        "Deir ez-Zor": "دير الزور",
        Raqqa: "الرقة",
    },
    LB: {
        Beirut: "بيروت",
        Tripoli: "طرابلس",
        Sidon: "صيدا",
        Tyre: "صور",
        Zahle: "زحلة",
        Byblos: "جبيل",
        Baalbek: "بعلبك",
    },
    PS: {
        Gaza: "غزة",
        Ramallah: "رام الله",
        Hebron: "الخليل",
        Nablus: "نابلس",
        Jenin: "جنين",
        Bethlehem: "بيت لحم",
        Jericho: "أريحا",
    },
    YE: {
        "Sana'a": "صنعاء",
        Sanaa: "صنعاء",
        Aden: "عدن",
        Taiz: "تعز",
        Hodeidah: "الحديدة",
        Mukalla: "المكلا",
        Ibb: "إب",
    },
    LY: {
        Tripoli: "طرابلس",
        Benghazi: "بنغازي",
        Misrata: "مصراتة",
        Sirte: "سرت",
        Sabha: "سبها",
        Tobruk: "طبرق",
    },
    MA: {
        Casablanca: "الدار البيضاء",
        Rabat: "الرباط",
        Marrakech: "مراكش",
        Fez: "فاس",
        Tangier: "طنجة",
        Agadir: "أكادير",
        Meknes: "مكناس",
        Oujda: "وجدة",
        Tetouan: "تطوان",
    },
    DZ: {
        Algiers: "الجزائر",
        Oran: "وهران",
        Constantine: "قسنطينة",
        Annaba: "عنابة",
        Blida: "البليدة",
        Setif: "سطيف",
    },
    TN: {
        Tunis: "تونس",
        Sfax: "صفاقس",
        Sousse: "سوسة",
        Kairouan: "القيروان",
        Bizerte: "بنزرت",
        Gabes: "قابس",
    },
    SD: {
        Khartoum: "الخرطوم",
        Omdurman: "أم درمان",
        "Port Sudan": "بورتسودان",
        Kassala: "كسلا",
        "El Obeid": "الأبيض",
    },
};

/**
 * Normalize a city name for AR-lookup. Strips diacritics, apostrophes,
 * pseudo-Arabic letters, common prefixes like leading "Al " / "El "
 * variations, and condenses whitespace. This lets us match the names
 * returned by `country-state-city` (which carry diacritics like "Şalālah",
 * "Al Buraymī", "Bahlā'") against the cleaner AR_CITIES keys.
 */
function normalizeCityKey(name) {
    if (!name) return "";
    let s = String(name)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // remove combining marks
        .replace(/[ʼʻʹˈˊˋʿʾ'`’‘ʹ]/g, "") // apostrophes/glottal marks
        .replace(/[Şş]/g, "s")
        .replace(/[ḑ]/g, "d")
        .replace(/[ḩ]/g, "h")
        .replace(/[ţţ]/g, "t")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
    // Drop apostrophe-only Arabic glottal letters that may remain
    return s;
}

/** Build a normalized AR map for a given country once per call. */
function arMapForCountry(isoCountryCode) {
    const raw = AR_CITIES[isoCountryCode];
    if (!raw) return null;
    const out = {};
    for (const [en, ar] of Object.entries(raw)) {
        out[normalizeCityKey(en)] = ar;
    }
    return out;
}

/** Return localized country name from ISO-2 code, falling back to English. */
export function localizedCountryName(isoCode, lang = "en") {
    if (!isoCode) return "";
    const name = countries.getName(isoCode, lang === "ar" ? "ar" : "en", { select: "official" });
    return name || countries.getName(isoCode, "en") || isoCode;
}

/** Return localized city name. */
export function localizedCityName(isoCountryCode, englishCityName, lang = "en") {
    if (!englishCityName) return "";
    if (lang !== "ar") return englishCityName;
    const map = arMapForCountry(isoCountryCode);
    if (!map) return englishCityName;
    const key = normalizeCityKey(englishCityName);
    return map[key] || englishCityName;
}

/** Format a stored "Country - City" using the given language. */
export function formatLocation(country_en, city_en, country_code, lang = "en") {
    const c = country_code
        ? localizedCountryName(country_code, lang)
        : country_en || "";
    const ct = localizedCityName(country_code, city_en, lang);
    if (!c && !ct) return "";
    return `${c} - ${ct}`;
}
